import type { FC } from 'react';
import React from 'react';

import type { ITextHolder } from './models';

export const TextHolder: FC<ITextHolder> = ({ text }) => {
    return <>{text}</>;
};
